<template>
    <div class="activity-indicator-pulse" />
</template>